import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormGroup,
  FormControl,
  FormBuilder,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'anihis-certificate-origin-health',
  templateUrl: './certificate-origin-health.component.html',
  styleUrls: ['./certificate-origin-health.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CertificateOriginHealthComponent {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      lastRabiesVaccination: new FormControl(''),
      lastContagDiseasesVaccination: new FormControl(''),
      lastTreatmentEndoEcto: new FormControl(''),
      lastTreatmentEcto: new FormControl(''),
      notes: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.form.valueChanges.subscribe((value) => this.formChange.emit(value));
  }

  get lastRabiesVaccination(): FormControl {
    return this.form.get('lastRabiesVaccination') as FormControl;
  }

  get lastContagDiseasesVaccination(): FormControl {
    return this.form.get('lastContagDiseasesVaccination') as FormControl;
  }

  get lastTreatmentEndoEcto(): FormControl {
    return this.form.get('lastTreatmentEndoEcto') as FormControl;
  }

  get lastTreatmentEcto(): FormControl {
    return this.form.get('lastTreatmentEcto') as FormControl;
  }

  get notes(): FormControl {
    return this.form.get('notes') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset();
  }
}
